import { createSlice } from '@reduxjs/toolkit'
import {getDocumentationTemplate, getLetterTypes} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';
const initialState= {
  documentationTemplates: [],
  letterTypes: [],
  loading: "idle",
  error: null }

const documentationTemplatesSlice = createSlice({
  name: 'documentationTemplates',
  initialState,
  reducers: {
    clearDocumentationTemplatesError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getDocumentationTemplate.pending]: (state) => {
        state.loading = "loading";
        state.error = null
      },
    [getDocumentationTemplate.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.documentationTemplates = action.payload
    },
    [getDocumentationTemplate.rejected]: (state, action) => {
        state.loading = "failed";
        state.error = action.error.message
      },    [getDocumentationTemplate.pending]: (state) => {
        state.loading = "loading";
        state.error = null
      },
    [getLetterTypes.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.letterTypes = action.payload
      },
    [getLetterTypes.rejected]: (state, action) => {
        state.loading = "failed";
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearDocumentationTemplatesError} = documentationTemplatesSlice.actions;
export default documentationTemplatesSlice.reducer